// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3N3cj","title":"Header_title__1WBBG","side":"Header_side__2LLhp"};